var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfflineEmpanelment1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10265_14853)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 25.7018V30.506C30.4998 30.7253 30.4125 30.9356 30.2574 31.0906C30.1022 31.2456 29.8918 31.3327 29.6725 31.3327H16.3275C16.218 31.3319 16.1097 31.3096 16.0089 31.2669C15.908 31.2243 15.8165 31.1622 15.7397 31.0842C15.6628 31.0062 15.6021 30.9138 15.561 30.8123C15.5199 30.7108 15.4991 30.6022 15.5 30.4927V20.4993H20.5C20.721 20.4993 20.933 20.4116 21.0893 20.2553C21.2456 20.099 21.3334 19.887 21.3334 19.666V14.666H29.6684C30.1275 14.666 30.5 15.0452 30.5 15.4927V18.6302L23.0009 26.1302L22.9959 29.6618L26.5342 29.6668L30.5 25.7018ZM31.1484 20.3393L32.3267 21.5177L25.845 27.9993L24.665 27.9977L24.6667 26.821L31.1484 20.3393Z",
    fill: "#013C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 14.666L15.5 18.8302H19.6667V14.666Z",
    fill: "#F6948B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10265_14853",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10265_14853"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10265_14853",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineEmpanelment1);
export default __webpack_public_path__ + "static/media/Offline Empanelment 1.fa0f2e6d098adb80de2aea04a5f5688f.svg";
export { ForwardRef as ReactComponent };